"use client"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/Components/ui/form"
import { useContext } from 'react'
import { PlanBuilderContext } from './Plan'
import DatePicker from "../ui/DatePicker"
import { ProjectIcon } from "../ui/Icons/TooltipIcon"
import { Layers, Workflow } from "lucide-react"
import { isWorkingDay } from "@/utils/GlobalConstants"

const formSchema = z.object({
    startDate: z.coerce.date()
        .refine((data) => isWorkingDay(data), {
            message: "Start date must be a working day",
        })
});

interface FrmProjectProps {
    projectTypeId: number;
}

const FrmProject = ({ projectTypeId }: FrmProjectProps) => {
    const props = useContext(PlanBuilderContext);

    const { reset, ...form } = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            startDate: props.projectStartDate ? new Date(props.projectStartDate) : new Date(),
        },
    });

    function onSubmit(formData: z.infer<typeof formSchema>) {
        props.updateProjectStartDate(formData.startDate);
    }

    return (
        <Form {...form} reset={reset}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <div className="">Stage: {props.projectLifecycleStage}</div>
                <FormField
                    control={form.control}
                    name="startDate"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Start Date</FormLabel>
                            <FormControl>
                                <DatePicker
                                    date={new Date(field.value)}
                                    setDate={field.onChange}
                                    disable={props.projectLifecycleStage !== "Initiation" && props.projectLifecycleStage !== "Planning"}
                                />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <div className="flex flex-row justify-between items-center">
                    <button className="flex flex-row items-center button-default w-min text-nowrap mr-2" disabled={props.projectLifecycleStage !== "Initiation" && props.projectLifecycleStage !== "Planning"}><ProjectIcon />Update Project</button>
                    {projectTypeId === 2 ?
                        <button className="flex flex-row items-center button-default w-min text-nowrap" onClick={(e) => { e.preventDefault(); props.addWorkstream(); }}><Workflow className="w-6 h-6 mr-2" />Add Workstream</button>
                        :
                        <button className="flex flex-row items-center button-default w-min text-nowrap" onClick={(e) => { e.preventDefault(); props.addWorkPackage(); }}><Layers className="w-6 h-6 mr-2" />Add Work Package</button>
                    }
                </div>
            </form>
        </Form>
    )
}

export default FrmProject